var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"btnWrap"},[_c('router-link',{staticClass:"btn",attrs:{"to":`/${ _vm.kyokucode }/stamprally_detail/${ _vm.channel }/${ _vm.id }/`}},[_vm._v("スタンプラリーへ戻る")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }